import React from 'react';
import PropTypes from 'prop-types';

const HTMLResultRow = ({ row }) => (
  <div dangerouslySetInnerHTML={{ __html: row.text }} />
);

HTMLResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default HTMLResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/HTMLResultRow.jsx